import { useCampaignContext } from 'context/CampaignContext';
import { useClientContext } from 'context/ClientContext';

import { DashboardTypes } from 'API';
import {
  useCampaignId,
  useCampaignPeriodId,
  useChildCampaignId,
  useClientCode,
  useSubCampaignId,
  useVideoParams,
} from 'customHooks/useParameters';
import { useContext, useEffect, useState } from 'react';
// import { useSearchParams } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

import reactSelect from 'react-select';
import styled from 'styled-components';
import { Container } from './Header.styled';
import { iconList } from 'assets/newAssets/SVG/additionalIconsForLinks/iconList';
import { IconButton } from 'components/style/Global';
import { useDeleteCustomReports, useUpdateCustomReports } from 'components/NewPortal/Main/OrganisationReport';

import { EditCampaignPeriodModal } from 'components/NewPortal/AddCampaignPeriodModal';

interface spendProps {
  clientFilterList: Array<{ code: string; country: string } | undefined>;
  dashType?: DashboardTypes;
  setCurrentPage?: (e: 'welcome' | 'dashboardSelector') => void;
}

type CustomSelectType = {
  dashType?: DashboardTypes;
};

export const CustomSelect = styled(reactSelect)<CustomSelectType>`
  position: relative;
  display: block;
  width: 100%; /* ${({ dashType }) => (dashType !== DashboardTypes.HOME ? '' : ' !important')}; */
  margin-bottom: 4px;
  margin-right: 4px;
  font-size: 0.9rem;
  font-family: 'FontRegular', sans-serif;
  font-weight: normal;
  color: ${({ theme }) => theme.primaryGray} !important;
  background: ${({ theme }) => theme.placeholderBackground} !important;
  border-radius: 10px;
  z-index: 10;

  .react-select__menu {
    /* background-color: ${({ dashType, theme }) =>
      dashType !== DashboardTypes.HOME ? theme.placeholderBackground : '#1a1b1e'} !important; */
    background-color: ${({ theme }) => theme.placeholderBackground};
    font-size: 12px;
  }
  /* width */
  .react-select__menu-list::-webkit-scrollbar {
    width: 10px;
  }
  /* Track */
  .react-select__menu-list::-webkit-scrollbar-track {
    /* background: ${({ dashType, theme }) =>
      dashType !== DashboardTypes.HOME ? theme.border : '#27292a'} !important; */
    background: ${({ theme }) => theme.border};
    border-radius: 10px;
  }
  /* Handle */
  .react-select__menu-list::-webkit-scrollbar-thumb {
    /* background: ${({ dashType, theme }) =>
      dashType !== DashboardTypes.HOME ? theme.scrollThumb : '#c9cacc'} !important; */
    background: ${({ theme }) => theme.scrollThumb};
    border-radius: 10px;
  }

  .react-select__control {
    background: ${({ dashType, theme }) => (dashType !== DashboardTypes.HOME ? theme.background : 'white')} !important;
    /* background: ${({ theme }) => theme.background}; */
    border: none;
    /* color: ${({ dashType, theme }) =>
      dashType !== DashboardTypes.HOME ? theme.secondaryGray : '#1a1b1e'} !important; */
    color: ${({ theme }) => theme.secondaryGray} !important;
  }
  .react-select__indicator {
    visibility: hidden;
  }

  .react-select__single-value {
    /* color: ${({ dashType, theme }) =>
      dashType !== DashboardTypes.HOME ? theme.primaryGray : '#c9cacc'} !important; */
    color: ${({ theme }) => theme.primaryGray} !important;
  }

  .react-select__value-container {
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .react-select__indicator-separator {
    width: 0;
  }
  .react-select__control--is-focused {
    box-shadow: 0 0 0 1px ${({ theme }) => theme.secondaryGray};
    border-color: ${({ theme }) => theme.secondaryGray};
    /* border-color: ${({ dashType, theme }) =>
      dashType !== DashboardTypes.HOME ? theme.secondaryGray : theme.primaryGray} !important; */
  }
  .react-select__control--menu-is-open {
    box-shadow: 0 0 0 1px ${({ theme }) => theme.secondaryGray};
    /* border-color: ${({ dashType, theme }) =>
      dashType !== DashboardTypes.HOME ? theme.secondaryGray : theme.primaryGray} !important; */
    border-color: ${({ theme }) => theme.secondaryGray};
  }
  .react-select__control:hover {
    box-shadow: 0 0 0 1px ${({ theme }) => theme.secondaryGray};
    /* border-color: ${({ dashType, theme }) =>
      dashType !== DashboardTypes.HOME ? theme.secondaryGray : theme.primaryGray} !important; */
    border-color: ${({ theme }) => theme.secondaryGray};
  }
  .react-select__control:hover .react-select__indicator {
    visibility: visible;
  }
  .react-select__option--is-selected {
    /* background-color: ${({ dashType, theme }) =>
      dashType !== DashboardTypes.HOME ? theme.secondaryGray : theme.primaryGray} !important; */
    background-color: ${({ theme }) => theme.secondaryGray};
  }
  .react-select__input-container {
    /* color: ${({ dashType, theme }) =>
      dashType !== DashboardTypes.HOME ? theme.secondaryGray : theme.primaryGray} !important; */
    color: ${({ theme }) => theme.secondaryGray} !important;
  }
`;

export const CampaignSelectComponent = (props: spendProps) => {
  const { setActiveOrganization, organizationList, organizationListWithCountry } = useClientContext();
  const { campaignList, activeCampaign, dashType, subCampaignList, permanentCampaignList, setPermanentCampaignList } =
    useCampaignContext();
  // const [searchParams, setSearchParams] = useSearchParams();
  const [, setSearchParamsAtomic] = useSearchParams();
  const [campaignID, setCampaignId, deleteCampID] = useCampaignId();
  const [subCamp, setSubCamp, deletesubCamID] = useSubCampaignId();
  const [childCamp, setChildCamp, deleteChildCampID] = useChildCampaignId();
  const [campaignPeriod, setCampaignPeriod, deleteCampaignPeriod] = useCampaignPeriodId();
  const [videoSource] = useVideoParams();

  const [org, setOrg, deleteOrgID] = useClientCode();
  const { setCurrentPage, clientFilterList } = props;

  //CLIENT SELECt
  const handleClientSelection = (e: string) => {
    const findOrg = organizationList.find((element) => element?.OrganizationId === e);
    setOrg(e);
    setActiveOrganization(findOrg);
    setCurrentPage !== undefined && setCurrentPage('dashboardSelector');
  };

  const handleCampaignSelection = (campaignName: any) => {
    const selectedCampaign = campaignList?.find((e) => e?.campaignId === campaignName);
    if (selectedCampaign) {
      setCampaignId(selectedCampaign.campaignId?.toString());
      // deleteCampaignPeriod();
      // deleteChildCampID();

      //TODO maybe: set childcampaign to 0

      if (subCampaignList && subCampaignList.length > 0) {
        if (subCamp === 'none') {
          const firsItem = subCampaignList[0];
          const subcampaignId = firsItem.subcampaignId;
          if (subcampaignId) {
            setSubCamp(subcampaignId?.toString());
          }
        }
      }
    }
  };

  const handleSubcampaignSelection = (val: string) => {
    const selectedSubcampaign = subCampaignList?.find((e) => e.name === val);
    setSubCamp(val);
  };

  // Organization validation is now handled in ClientContext
  useEffect(() => {
    if (org !== 'none' && organizationList.length > 0) {
      // Just trigger dashboard selector page if we have a valid org
      // The actual validation and setActiveOrganization is done in ClientContext
      setCurrentPage !== undefined && setCurrentPage('dashboardSelector');
    }
  }, [org, organizationList, setCurrentPage]);

  type ACdetails = { subcampaign: { [key: number]: any } };

  const clientsDropdown =
    organizationListWithCountry &&
    organizationListWithCountry?.map((e) => {
      return {
        label: e?.Organization + ' (' + e?.country.countryEnum + ')',
        value: e?.OrganizationId,
      };
    });

  const campaignsDropdown =
    campaignList &&
    campaignList.map((e) => {
      return {
        label: e?.campaign,
        value: e?.campaignId,
      };
    });

  const subCampaignDropdown =
    subCampaignList &&
    subCampaignList
      .filter((e) =>
        activeCampaign?.authorized === true
          ? e
          : e.subcampaignId !== null &&
            e.subcampaignId !== undefined &&
            activeCampaign?.subcampaign.hasOwnProperty(e.subcampaignId),
      )
      .map((e) => {
        return {
          label: e.name,
          value: e.subcampaignId,
        };
      });

  function checkPublishedSubcampaigns2(el: ACdetails) {
    // OVO TU NE VRACA OOH KAMPANJU NAZAD; NE ZNAM ZASTO
    if (dashType === DashboardTypes.TV || dashType === DashboardTypes.RADIO) {
      // za TV/RADIO published status je na stvarnim subcampaign ključevima, ne samo na -1
      if (dashType === DashboardTypes.TV && el.subcampaign[-1]?.published.BVOD === true) {
        return true;
      }
      return Object.entries(el.subcampaign).some(([, value]) => (value as any)?.published?.[dashType] === true);
    }
    const isDashTypePublished = offlineNOTVorRADIO && el.subcampaign[-1].published[dashType] === true;
    return isDashTypePublished;
  }
  const offlineNOTVorRADIO =
    dashType === DashboardTypes.CINEMA ||
    dashType === DashboardTypes.DIGITAL ||
    dashType === DashboardTypes.PRINT ||
    dashType === DashboardTypes.OOH;
  // Direct match (umbrella → child selected) OR grandparent search (umbrella → child → period selected)
  const parentCampaignForDropdown = activeCampaign?.parentReference
    ? (campaignList?.find((e) => e?.campaignId === activeCampaign.parentReference) ??
      campaignList?.find((e) => e?.childCampaigns?.some((c) => c?.campaignId === activeCampaign.parentReference)))
    : null;

  const childCampaingDropdown = parentCampaignForDropdown
    ? parentCampaignForDropdown.childCampaigns
        ?.filter((e) => e?.dashboardType.some((el) => el === dashType))
        .filter((child) => (activeCampaign!.authorized ? child : checkPublishedSubcampaigns2(child as any)))
        ?.map((e) => {
          return {
            label: e?.campaign,
            value: e?.campaignId,
          };
        })
        .concat(
          dashType === DashboardTypes.TV || dashType === DashboardTypes.RADIO
            ? []
            : !activeCampaign!.authorized &&
                offlineNOTVorRADIO &&
                parentCampaignForDropdown.subcampaign[-1].published[dashType] === false
              ? []
              : {
                  label: campaignList?.find((e) => e?.campaignId === Number(campaignID))?.campaign,
                  value: campaignList?.find((e) => e?.campaignId === Number(campaignID))?.campaignId,
                },
        )
    : activeCampaign?.childCampaigns && activeCampaign.childCampaigns.length > 0
      ? activeCampaign.childCampaigns
          .filter((e) => e?.dashboardType.some((el) => el === dashType))
          .filter((child) => (activeCampaign.authorized ? child : checkPublishedSubcampaigns2(child as any)))
          .map((e) => {
            return {
              label: e?.campaign,
              value: e?.campaignId,
            };
          })
          .concat(
            dashType === DashboardTypes.TV || dashType === DashboardTypes.RADIO
              ? []
              : !activeCampaign.authorized &&
                  offlineNOTVorRADIO &&
                  activeCampaign.subcampaign[-1].published[dashType] === false
                ? []
                : {
                    label: campaignList?.find((e) => e?.campaignId === Number(campaignID))?.campaign,
                    value: campaignList?.find((e) => e?.campaignId === Number(campaignID))?.campaignId,
                  },
          )
      : null;

  const handleChildCampaignSelection = (campaignID: number) => {
    // When a period is selected, parentReference points to the child (not umbrella),
    // so use parentCampaignForDropdown to reliably identify the "entire umbrella" option.
    const umbrellaId = parentCampaignForDropdown?.campaignId ?? activeCampaign?.parentReference;
    if (campaignID === umbrellaId) {
      // Clear child and period atomically in one call — individual hook setters each read
      // a stale searchParams snapshot and would overwrite each other.
      setSearchParamsAtomic((prev) => {
        const next = new URLSearchParams(prev.toString());
        next.delete('childCampaignID');
        next.delete('campaignPeriodID');
        next.delete('subcampaignID');
        return next;
      });
      return;
    } else {
      setChildCamp(campaignID.toString());
    }
    // setChildCamp(campaignID.toString());
  };
  const dashIsOK = dashType === 'DIGITAL' || dashType === 'PRINT' || dashType === 'OOH' || dashType === 'CINEMA';
  const campaignPeriodsDropdown =
    activeCampaign?.campaignPeriods &&
    activeCampaign?.campaignPeriods.length > 0 &&
    activeCampaign?.campaignPeriods
      .flatMap((el) => {
        if (el?.authorized) {
          return el;
        } else {
          if (
            dashType === 'DIGITAL' ||
            dashType === 'PRINT' ||
            dashType === 'OOH' ||
            dashType === 'CINEMA' ||
            dashType === 'INSOURCE_DATA'
          ) {
            const subcampaign = el?.subcampaign[-1];
            if (subcampaign?.published[dashType as keyof typeof subcampaign.published] === true) {
              return el;
            } else {
              return [];
            }
          }
        }
      })
      ?.map((e) => {
        return {
          label: e?.CustomReportName,
          value: e?.CustomReportID,
        };
      })
      .concat(
        (() => {
          const targetCampaign = campaignList?.find((e) => e?.campaignId === Number(campaignID));
          if (!targetCampaign) return [];
          if (targetCampaign.authorized) {
            return { label: "Entire campaign's period", value: targetCampaign.campaignId };
          }
          if (!dashIsOK) return [];
          // For unauthorized users, subcampaign[-1] may be inflated by period propagation.
          // Only show "Entire campaign's period" if the active campaign has direct
          // (non-period) published subcampaigns, not just period-level published state.
          // If no numeric subcampaign keys exist, fall back to subcampaign[-1].
          const hasPeriods = (activeCampaign?.campaignPeriods?.length ?? 0) > 0;
          const directKeys = Object.keys(activeCampaign?.subcampaign ?? {}).filter((k) => k !== '-1');
          const isDirectlyPublished = hasPeriods
            ? directKeys.length > 0
              ? directKeys.some((k) => (activeCampaign?.subcampaign as any)?.[k]?.published?.[dashType] === true)
              : // No numeric subcampaign keys — use rawPublished (pre-propagation backend value)
                // to avoid reading the inflated subcampaign[-1] set by period propagation.
                ((activeCampaign?.subcampaign[-1] as any)?.rawPublished?.[dashType] ?? false) === true
            : activeCampaign?.subcampaign[-1]?.published[dashType] === true;
          return isDirectlyPublished ? { label: "Entire campaign's period", value: targetCampaign.campaignId } : [];
        })()
      );

  useEffect(() => {
    if (campaignPeriodsDropdown && campaignPeriodsDropdown.length > 0) {
      if (campaignPeriod !== 'none') {
        const findPeriod = campaignPeriodsDropdown.find((e) => e.value === Number(campaignPeriod));
        if (!findPeriod) {
          deleteCampaignPeriod();
        }
      }
    }
  }, [campaignPeriodsDropdown]);

  const handleCampaignPeriodSelection = (campaignPeriodID: number) => {
    if (campaignPeriodID === Number(campaignID)) {
      deleteCampaignPeriod();
      return;
    } else {
      setCampaignPeriod(campaignPeriodID.toString());
    }
  };
  const deleteIcon = iconList.find((icon) => icon === 'delete');
  const [deleteCustomRep] = useDeleteCustomReports();
  const editIcon = iconList.find((icon) => icon === 'edit');
  const [editModal, setEditModal] = useState(false);

  return (
    // <Container dashType={dashType}>
    <Container dashType={''}>
      <>
        {clientsDropdown.length <= 4 && dashType === DashboardTypes.HOME ? (
          <div className="buttonsListClients">
            {/* THIS IS ONLY IF THE LIST IS LESS THAN 4 AND IT WILL BE DISPLAYED AS BUTTONS */}
            {clientsDropdown.map((client) => {
              return (
                <button onClick={() => client.value !== undefined && handleClientSelection(client.value)}>
                  {client.label}
                </button>
              );
            })}
          </div>
        ) : (
          <>
            {dashType === DashboardTypes.HOME /* || dashType === DashboardTypes.FLOWCHART */ && (
              <CustomSelect
                dashType={dashType}
                onChange={(sel: any) => handleClientSelection(sel.value)}
                options={clientsDropdown}
                value={clientsDropdown?.find((e) => e.value === org)}
                className="react-select-container"
                id="sel1"
                classNamePrefix="react-select"
              ></CustomSelect>
            )}
          </>
        )}
      </>

      {dashType !== DashboardTypes.HOME && dashType !== DashboardTypes.FLOWCHART && (
        <>
          {
            <CustomSelect
              options={campaignsDropdown}
              onChange={(sel: any) => handleCampaignSelection(sel.value)}
              value={campaignsDropdown?.find((e) => e.value === Number(campaignID))}
              id="sel2"
              className="react-select-container"
              classNamePrefix="react-select"
            ></CustomSelect>
          }
          {childCampaingDropdown && (
            <CustomSelect
              options={childCampaingDropdown}
              onChange={(sel: any) => handleChildCampaignSelection(sel.value)}
              value={
                activeCampaign?.campaignId === Number(campaignID)
                  ? childCampaingDropdown?.find((e) => e.value === Number(campaignID))
                  : childCampaingDropdown?.find((e) => e.value === Number(childCamp))
              }
              id="sel3"
              className="react-select-container"
              classNamePrefix="react-select"
            ></CustomSelect>
          )}
          {dashType !== DashboardTypes.TV &&
            dashType !== DashboardTypes.RADIO &&
            campaignPeriodsDropdown &&
            campaignPeriodsDropdown.length > 0 && (
              <>
                <CustomSelect
                  options={campaignPeriodsDropdown}
                  onChange={(sel: any) => handleCampaignPeriodSelection(sel.value)}
                  // value={childCampaingDropdown[childCampaignIndex]}
                  // value={childCampaingDropdown?.find((e) => e.value === Number(childCamp))}
                  value={
                    campaignPeriod !== 'none'
                      ? (campaignPeriodsDropdown?.find((e) => e.value === Number(campaignPeriod)) ?? null)
                      : childCamp !== 'none'
                        ? (campaignPeriodsDropdown.find((e) => e.value === Number(childCamp)) ?? null)
                        : (campaignPeriodsDropdown.find((e) => e.value === Number(campaignID)) ?? null)
                  }
                  id="sel3"
                  className="react-select-container"
                  classNamePrefix="react-select"
                ></CustomSelect>
                {activeCampaign.parentReference && activeCampaign.authorized && (
                  <IconButton
                    onClick={() => {
                      deleteCustomRep().then((res) => {
                        if (res) {
                          deleteCampaignPeriod();
                          const periods = activeCampaign.campaignPeriods?.filter(
                            (e) => e?.CustomReportID !== Number(campaignPeriod),
                          );
                          const campaign = permanentCampaignList?.find(
                            (e) => e?.campaignId === activeCampaign.parentReference,
                          );
                          const newActiveCampaign = { ...campaign, campaignPeriods: periods };
                          const newCampaignList = permanentCampaignList?.map((e) => {
                            if (e?.campaignId === activeCampaign.parentReference) {
                              return newActiveCampaign;
                            }
                            return e;
                          });
                          setPermanentCampaignList(newCampaignList as any);
                          window.location.reload();
                        }
                      });
                    }}
                  >
                    <div
                      title="Delete Date Report"
                      style={{ fontSize: '18px', justifyContent: 'center', cursor: 'pointer', alignContent: 'center' }}
                      className="svg material-symbols-outlined  "
                    >
                      {deleteIcon}
                    </div>
                  </IconButton>
                )}
                {activeCampaign.parentReference && activeCampaign.authorized && (
                  <IconButton
                    onClick={() => {
                      setEditModal(true);
                    }}
                  >
                    <div
                      title="Edit Date Report"
                      style={{ fontSize: '18px', justifyContent: 'center', cursor: 'pointer', alignContent: 'center' }}
                      className="svg material-symbols-outlined  "
                    >
                      {editIcon}
                    </div>
                  </IconButton>
                )}
              </>
            )}

          {subCampaignList.length > 0 && videoSource !== 'BVOD' && (
            <CustomSelect
              options={subCampaignDropdown}
              onChange={(sel: any) => handleSubcampaignSelection(sel.value)}
              value={subCampaignDropdown?.find((e) => e.value === Number(subCamp))}
              className="react-select-container"
              id="sel3"
              classNamePrefix="react-select"
            ></CustomSelect>
          )}
        </>
      )}
      {editModal && <EditCampaignPeriodModal setEditModal={setEditModal}></EditCampaignPeriodModal>}
    </Container>
  );
};
